export default __webpack_public_path__ + "acdb88f6e91fa4dfb129266b103cb5b0.png";